/* eslint-disable no-shadow */
const getDefaultState = () => ({
  banners: [],
  messages: [],
})

const state = getDefaultState()

const mutations = {
  SET_BANNERS(state, banners) {
    state.banners = banners
  },
  SET_MESSAGES(state, messages) {
    state.messages = messages
  },
  DISMISS_BANNER(state, id) {
    state.banners = state.banners.filter(b => b.id !== id)
  },
  DISMISS_MESSAGE(state, id) {
    const msg = state.messages.find(m => m.id === id)
    if (msg) msg.show = false
  },
}

const actions = {
  async fetchNotifications({ commit }, komshipAxiosIns) {
    try {
      const lastFetch = localStorage.getItem('lastNotifFetch')
      const now = Date.now()

      if (lastFetch && now - parseInt(lastFetch, 10) < 60 * 1000) {
        return
      }

      localStorage.setItem('lastNotifFetch', now.toString())

      const response = await komshipAxiosIns.get('/v2/notification-bar', {
        params: { product: 'partner' },
      })

      const responseData = response?.data?.data

      if (!responseData || !Array.isArray(responseData)) {
        commit('SET_BANNERS', [])
        commit('SET_MESSAGES', [])
        return
      }

      const allItems = responseData.flat()
      const banners = allItems.filter(item => item.type === 'banner')
      const messages = allItems.filter(item => item.type === 'message')

      commit('SET_BANNERS', banners)
      commit('SET_MESSAGES', messages)
    } catch (error) {
      console.error('Error fetching notifications:', error)
      commit('SET_BANNERS', [])
      commit('SET_MESSAGES', [])
    }
  },
}

const getters = {
  banners: state => state.banners,
  messages: state => state.messages,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
